module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'background-blue ' + 'step-' + _vm.stage
  }, [_c('div', {
    style: (!_vm.SITE_CONFIG.modules_open.skiletting.open ? 'visibility: hidden;' : '')
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps,
      "theme": "light"
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e()], 1), _vm._v(" "), _c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(parseInt(_vm.$route.params.person)) ? _c('div', {
    staticClass: "remove-user",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.remove-title', {
    skier: ''
  })) + " "), _c('button', {
    staticClass: "white small"
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.4
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('div', {
    class: 'content center a-step step-' + 10
  }, [(_vm.$route.params.person === '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-first-skier')))]) : _vm._e(), _vm._v(" "), (_vm.$route.params.person !== '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-skier-x', {
    number: parseInt(_vm.$route.params.person) + 1
  })))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'box checkboxes',
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, [_c('Checkbox', {
    attrs: {
      "special-class": "rental-user",
      "label": "Ny",
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "special-class": "rental-user",
      "label": "Sparad",
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.tabSaved) ? _c('div', {
    staticClass: "flex"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "control"
  }, [_c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.skiers.length && !_vm.loadingSkiers) ? _c('div', [_c('div', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('Note', {
    attrs: {
      "title": "Inga åkare",
      "color": "white"
    }
  }, [_c('p', [_vm._v("Vi hittade inga sparade åkare.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.loadingSkiers) ? _c('div', [_c('div', {
    staticClass: "control"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loadingSkiers,
      "static": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.skiers.length) ? _c('div', [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "label no-left-margin"
  }, [_vm._v("Välj bland dina åkare")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.skiersAsSelect,
      "valuebinder": _vm.skierId,
      "validated": _vm.skierId,
      "label": "Välj åkare"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.skierId = $event
      },
      "changed": _vm.setSkier
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.tabSaved) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "label no-left-margin"
  }, [_vm._v(_vm._s(_vm.$t('general.name')))]), _vm._v(" "), _c('div', {
    class: 'flex flexer ' + (_vm.validatedName ? 'selected' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "nameInput",
    staticClass: "input",
    attrs: {
      "tabindex": "0",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": _vm.inValidateName,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.validateName($event);
        _vm.validateStep10($event);
      },
      "blur": function($event) {
        _vm.validateName($event);
        _vm.validateStep10($event);
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffix",
    on: {
      "click": _vm.focusName
    }
  }, [(!_vm.validatedName) ? _c('icon', {
    attrs: {
      "name": "empty",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validatedName) ? _c('icon', {
    attrs: {
      "name": "circle-green-minus",
      "scale": 1.5
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('div', {
    class: 'content center a-step step-' + 13 + (_vm.stage < 13 ? ' disabled' : '')
  }, [(parseInt(_vm.$route.params.person) > 0) ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('skirental.rental-period-title')) + ": "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.pickedStartDate))
    }
  })])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.rental-period-text')))])]) : _vm._e(), _vm._v(" "), (_vm.delivery) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_c('div', {
    staticClass: "inline-block min-width white-text",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.title')))], 1), _vm._v(" "), _c('ul', [_vm._l((_vm.deliveryMessages), function(message, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(message)
      }
    }, [_vm._v(_vm._s(message))])
  }), _vm._v(" "), (_vm.possibleWithStorage) ? _c('li', [_c('strong', [_vm._v("OBS! Nattförvaring.")]), _vm._v(" Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$route.params.person) === 0) ? _c('div', {
    staticClass: "inline-block min-width"
  }, [(_vm.stage <= 13) ? _c('label', {
    staticClass: "label no-left-margin"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-days')))]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": _vm.selectedDays,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.stage >= 10) ? _c('div', {
    class: 'content inline-block a-step step-' + 16 + (_vm.stage > 10 ? ' inline-block' : '') + ' ' + (_vm.stage < 16 ? ' disabled' : '')
  }, [(_vm.stage <= 16) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-age')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.options), function(option) {
    return ((!_vm.selectedAge || _vm.selectedAge === option.value)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedAge === option.value),
          'has-description': option.subtitle
      },
      on: {
        "click": function($event) {
          return _vm.setAge(option.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n            "), (option.subtitle /*&& stage === 16*/ ) ? _c('span', [_vm._v(_vm._s(option.subtitle))]) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.stage == 20) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 20) ? _c('div', {
    class: 'content a-step step-' + 20 + (_vm.stage > 16 ? ' inline-block' : '')
  }, [(_vm.stage <= 20) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skirental.what-to-rent')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.categories), function(category) {
    return (((!_vm.selectedCategory || _vm.selectedCategory === category.slug) && (!category.parent) && category.name)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedCategory === category.slug)
      },
      domProps: {
        "innerHTML": _vm._s((_vm.selectedCategory === 'other') ? ((
          _vm.subCategories && _vm.subCategories[_vm.selectedSubCategory] && _vm.subCategories[_vm.selectedSubCategory].name
        ) ? _vm.subCategories[_vm.selectedSubCategory].name : _vm.$t('skirental.other-equipment')) : category.name)
      },
      on: {
        "click": function($event) {
          return _vm.setCategory1(category.slug, category)
        }
      }
    }) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.stage == 30) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 30) ? _c('div', {
    class: 'content a-step step-' + 30 + (_vm.stage > 16 ? ' inline-block' : '')
  }, [_c('div', {
    staticClass: "label max-mobile label-products"
  }, [_vm._v(_vm._s(_vm.$t('skirental.what-to-rent')))]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.products), function(product, key) {
    return ((!_vm.selectedType || _vm.selectedType === key) && _vm.showProduct(key)) ? _c('div', {
      class: {
        button: true,
          'small-text': true,
          white: true,
          checked: (_vm.selectedType === key),
          'has-description': (product.description && _vm.stage === 30)
      },
      on: {
        "click": function($event) {
          return _vm.setType(key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(product.title) + "\n            "), (_vm.stage == 30) ? _c('span', [_vm._v(_vm._s(product.description))]) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.stage >= 40) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 40) ? _c('div', {
    class: 'content a-step step-' + 40
  }, [_c('h1', {
    staticClass: "level-phone"
  }, [_vm._v(_vm._s(_vm.$t('skirental.pick-level')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    class: 'box ' + (_vm.searchPackage === 'beginner' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('beginner')
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.beginner')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.2')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]), _vm._v(" "), _c('div', {
    class: 'box ' + (_vm.selectedAge !== 'children' ? 'larger' : '') + ' ' + (_vm.searchPackage === 'intermediate' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('intermediate')
      }
    }
  }, [(_vm.selectedAge !== 'children') ? _c('div', {
    staticClass: "banner"
  }, [_vm._v(_vm._s(_vm.$t('general.popular-choice')))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.average')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.4')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]), _vm._v(" "), (_vm.selectedAge !== 'children') ? _c('div', {
    class: 'box ' + (_vm.searchPackage === 'advanced' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('advanced')
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.advanced')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.5')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.6')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [(_vm.currentStepValid || (_vm.stage === 10 || _vm.stage === 13)) ? _c('button', {
    staticClass: "block border",
    attrs: {
      "disabled": !_vm.currentStepValid
    },
    on: {
      "click": _vm.goForward
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704fa42c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalUser.vue
// module id = 991
// module chunks = 0